import React, { useState } from "react";
import { Backdrop, Modal } from "@mui/material";
import ImagenSegura from "../ImagenSegura";
import NotDesign from "../../assets/design-not-available.png";
import ItemCompraCard, { urlImagen } from "./ItemCompraCard";

const FUENTE = "Bricolage Grotesque";

const Seccion = ({ titulo, items, tipo, eventoNombre, onExpandir, renderAcciones }) =>
  items?.length > 0 && (
    <>
      <h5 style={{ fontWeight: 600, color: "#0B0060", marginBottom: 20, fontFamily: FUENTE, fontSize: 24 }}>{titulo}</h5>
      <div className="d-flex justify-content-center flex-wrap gap-4 mb-5">
        {items.map((item) => (
          <ItemCompraCard
            key={`${tipo}-${item.id}`}
            item={item}
            tipo={tipo}
            eventoNombre={eventoNombre}
            onExpandir={onExpandir}
            acciones={renderAcciones?.(item, tipo)}
          />
        ))}
      </div>
    </>
  );

/* Tickets y vouchers de una compra, en tarjetas; tocando la imagen se amplía.
 * renderAcciones(item, tipo) agrega botones a cada tarjeta. */
const ItemsCompra = ({ compra, renderAcciones }) => {
  const [ampliada, setAmpliada] = useState(null);
  const eventoNombre = compra?.carrito?.evento?.evento;
  const vacia = !compra?.tickets?.length && !compra?.vouchers?.length;

  return (
    <>
      <Seccion titulo="Tickets" items={compra?.tickets} tipo="ticket" eventoNombre={eventoNombre} onExpandir={setAmpliada} renderAcciones={renderAcciones} />
      <Seccion titulo="Vouchers" items={compra?.vouchers} tipo="voucher" eventoNombre={eventoNombre} onExpandir={setAmpliada} renderAcciones={renderAcciones} />
      {vacia && (
        <p className="text-center w-100 py-4" style={{ color: "#71717A", fontFamily: FUENTE }}>
          No hay entradas disponibles para esta compra
        </p>
      )}

      <Modal open={Boolean(ampliada)} onClose={() => setAmpliada(null)} closeAfterTransition BackdropComponent={Backdrop} BackdropProps={{ timeout: 500 }}>
        <div
          onClick={() => setAmpliada(null)}
          style={{
            position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", outline: "none",
            width: "90%", height: "90%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center",
          }}
        >
          {ampliada && (
            <ImagenSegura
              src={urlImagen(ampliada.tipo, ampliada.id)}
              alt="Entrada ampliada"
              style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", boxShadow: "0 8px 32px rgba(0,0,0,0.2)", borderRadius: 8 }}
              showLoader
              fallbackSrc={NotDesign}
            />
          )}
          <div style={{ marginTop: 20, color: "white", fontSize: 14, fontFamily: FUENTE, textShadow: "0 2px 4px rgba(0,0,0,0.5)" }}>
            (Tocá en cualquier lugar para cerrar)
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ItemsCompra;
